import { render, staticRenderFns } from "./GridContainerItem.vue?vue&type=template&id=21b988b7&scoped=true&"
import script from "./GridContainerItem.vue?vue&type=script&lang=js&"
export * from "./GridContainerItem.vue?vue&type=script&lang=js&"
import style0 from "./GridContainerItem.vue?vue&type=style&index=0&id=21b988b7&lang=scss&scoped=true&"
import style1 from "./GridContainerItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b988b7",
  null
  
)

export default component.exports